import { IFullPlanDetail, IFullPlanDetailPPO } from "../../../interfaces/api";

interface ICompareStick {
  data: IFullPlanDetail | IFullPlanDetailPPO;
  activePlan: number;
  footer?: boolean;
  planNumber: number;
}

const CompareStickMobileRecommend: React.FC<ICompareStick> = (data) => {
  return (
    <div
      style={{
        padding: "20px 8px 10px 8px",
        backgroundColor:
          data.activePlan === data.planNumber ? "#1B54C2" : "#F5F9FD",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        cursor: "pointer",
      }}
    >
      {!data.footer && (
        <div
          className="secondary-color text-uppercase font-weight-600"
          style={{
            fontSize: "18px",
            textAlign: "left",
            height: "110px",
            overflow: "auto",
            color: data.activePlan === data.planNumber ? "white" : "#003A5D",
          }}
        >
          {data.data.PlanDetails[0].company[0].healthPlan[0].pbp[0].name}{" "}
          {data.data.PlanDetails[0].company[0].healthPlan[0].pbp[0].id}
        </div>
      )}
    </div>
  );
};

export default CompareStickMobileRecommend;
